import { IUserStore } from 'interfaces/store/IUserStore';
import create, { StateCreator } from 'zustand';
import api from 'services/api';
import { IStore } from 'interfaces/store/IStore';
import { persist } from "zustand/middleware";
import { STORE_KEY } from 'constants/APP_CONSTANTS';
import { removeUserFromMultipleLocalStorageKeys } from 'utils/notFoundUserLocalStorageData';
import { ATTEPTS_USERS_FROMDB, FIRST_ACCESS_REQUERED_LOCAL_STORAGE_KEY } from 'constants/LOGIN_ATTEMPTS';
import { CONNECTED_ERP_SERVICE, CONNECTED_ERP_SERVICE_FAILED, CONNECTED_ERP_SERVICE_SUCCESS } from 'constants/ERP_CONSTANTS';
import { getERPConnectionCode, getIsConnectERPService } from 'utils/erpConnectionCodeHandler';

const USER_DATA = {
    user: {
      id: "",
      name: "",
      hasATempPassword: false,
    },
    bearerToken: {
      token: "",
      refreshToken: "",
      expires: "",
    },
  } as IUserStore;

const store: StateCreator<IStore> = (set, get) => ({
    ...USER_DATA,
    getApi: () => {
        const token = get().bearerToken.token;
        api.defaults.headers.common.authorization = token ? `Bearer ${token}` : "";
        return api;
      },
    signin: async (params) => {
        const api = get().getApi();
        const { data } = await api.post<IUserStore & { connectERPService: boolean }>("/auth/login", params);
        api.defaults.headers.common.authorization = `Bearer ${data.bearerToken.token}`;
        const {connectERPService, ...rest} =  data
        const erpServiceStatus = getERPConnectionCode(connectERPService)
        set(() => ({
          ...get(),
          ...rest,
          [CONNECTED_ERP_SERVICE]: erpServiceStatus
        }));
        const document = params.username
        removeUserFromMultipleLocalStorageKeys([FIRST_ACCESS_REQUERED_LOCAL_STORAGE_KEY, ATTEPTS_USERS_FROMDB], document)
        if(data?.user?.role === "client") await get().syncClientData(data);
    },
    syncClientData: async(data?: IUserStore) => {
      const api = get().getApi();
      const currentData = data || get();
      try {
        await api.get("/clients/sync");
        if (getIsConnectERPService(currentData[CONNECTED_ERP_SERVICE])) return true
        set(() => ({
          ...get(),
          [CONNECTED_ERP_SERVICE]: CONNECTED_ERP_SERVICE_SUCCESS,
        }));
        return true
      } catch (error) {
        set(() => ({
          ...currentData,
          [CONNECTED_ERP_SERVICE]: CONNECTED_ERP_SERVICE_FAILED,
        }));
        return false
      }
    },
    signout: async () => {
        const api = get().getApi();
        api.defaults.headers.common.authorization = "";
          set(() => ({
            ...get(),
            ...USER_DATA,
          }));
      },
      renewToken: async () => {
        try {
          const api = get().getApi();
          const { data } = await api.post("/auth/refresh", {
            refreshToken: get().bearerToken.refreshToken,
          });
          api.defaults.headers.common.authorization = `Bearer ${data.bearerToken.token}`;
          set(() => ({
            ...get(),
            ...data,
          }));
        } catch (err) {

        }
      },
      updatePassword: async (params) => {
        const api = get().getApi();
        try {
          await api.post("/auth/new_password", params);
        } catch(err) {
          //
        } finally {
          api.defaults.headers.common.authorization = "";
          set(() => ({
            ...get(),
            ...USER_DATA,
          }));
        }
      },
  });

const useStore = create(persist(store, {name: STORE_KEY}));

export default useStore;